import type { Control } from 'react-hook-form';
import { FormMobilePhoneInput, FormTextInput } from '@/components';
import type { InviteUserSchema } from '../../models';

interface InviteUserPersonalDataCardProps {
  control: Control<InviteUserSchema>;
}

const InviteUserPersonalDataCard = ({
  control,
}: InviteUserPersonalDataCardProps) => (
  <div className='bg-white rounded-lg p-6 border border-gray-200 shadow-sm'>
    <h3 className='text-lg font-semibold text-gray-800 mb-4'>
      Datos del usuario
    </h3>
    <div className='flex flex-col gap-4'>
      <div className='flex gap-4'>
        <div className='flex-1'>
          <FormTextInput
            name='firstName'
            placeholder='Nombre'
            control={control}
            required
            autoFocus
          />
        </div>
        <div className='flex-1'>
          <FormTextInput
            name='lastName'
            placeholder='Apellido'
            control={control}
            required
          />
        </div>
      </div>
      <div className='flex gap-4'>
        <div className='flex-1'>
          <FormMobilePhoneInput name='phone' control={control} required />
        </div>
        <div className='flex-1'>
          <FormTextInput
            name='email'
            placeholder='Email'
            control={control}
            required
          />
        </div>
      </div>
    </div>
  </div>
);

export default InviteUserPersonalDataCard;
